export default import.meta.ROLLDOWN_FILE_URL_3cJ8ffrrqqP95EATnvlgHw